import Cookies from 'js-cookie';
import logo from '../assets/Ecosystm-Awards-Logo.svg';
import { COOKIE_NAME } from '../constants/Constants';
function Thankyou() {
    return (
        <section className="text-gray-600 body-font relative h-full">
            <div className="container px-5 py-10 mx-auto">
                <div className="flex flex-col text-white text-center mx-auto lg:w-9/12 md:w-2/3 bg-red-500 sm:bg-right rounded p-5 pb-10 description-background">
                    <div className="w-full my-10 md:mb-20"><img src={logo} className="lg:h-28 sm:h-16 h-12" alt="Ecosystm Logo" /></div>
                    {/* <h1 className="sm:text-3xl lg:text-3xl text-xl font-black title-font mb-4">Thank You for your response!</h1> */}
                    <p className="text-xl sm:text-2xl font-medium mb-4 text-black">Thanks for your nomination for the Ecosystm Digital Futures Awards. We are evaluating your nomination and will let you know if you have been shortlisted. If you have any questions about the submission, or the status of your nomination, please email us at <a className="text-blue-400 hover:underline visited:text-purple-600" href="mailto: info@ecosystm360.com">info@ecosystm360.com</a>.</p>
                    <br />
                    <div className="px-2 py-3 w-full flex justify-center">
                        <button onClick={reSubmitForm} className="flex text-white bg-red-500 border-0 py-2 px-8 focus:outline-none hover:bg-red-600 rounded text-lg">Submit Another Nomination</button>
                    </div>
                </div>
            </div>
        </section>
    )
}

function reSubmitForm(){
    Cookies.remove(COOKIE_NAME);
    window.location.reload();
}

export default Thankyou
